import { Box, createStyles, Flex, Text } from "@mantine/core";

import AddButton from "../../../components/AddButton";
import FacilityTypeTable from "../../../components/FacilityTypeTable";
import FacilityTypeModal from "../../../containers/FacilityTypeModal";
import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CustomPagination from "../../../components/Pagination/CustomPagination";
import { getFacilityTypes } from "../../../services/facility";
import { TrackPageView } from "../../../config/mixpanelConfig";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { useNavigate } from "react-router-dom";
import { MdKeyboardArrowLeft } from "react-icons/md";

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
  },
  btn: {
    marginLeft: "auto",
    marginTop: 50,
    marginInline: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
  },
  mymodal: {
    width: 818,
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
  },
  mwd: {
    width: "100%",
  },
  pagination: {
    margin: "1rem 0",
    display: "flex",
    alignItems: "end",
    justifyContent: "end",
  },
  table: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100vh",
    marginInline: 10,
  },
}));

const FacilityType = (props) => {
  const { profile, facilityTypes } = useSelector((state) => ({
    profile: state?.profile,
    facilityTypes: state.facility.facilityTypes,
  }));

  const [currentPage, setCurrentPage] = useState(1);
  const [opened, { open, close }] = useDisclosure(false);
  const { classes } = useStyles();
  const navigate = useNavigate();

  useEffect(() => {
    TrackPageView("Facility Type");
  }, []);

  useEffect(() => {
    getFacilityTypes(currentPage);
  }, [currentPage]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <Box fluid className={classes.content}>
      <FacilityTypeModal
        opened={opened}
        close={close}
        title={"Facility Type"}
      />
      <AppNavbar title="Facility Settings" profile={profile} />
      <Box className={classes.btn}>
        <Flex
          gap={1}
          align={"center"}
          onClick={() => navigate("/home/facility")}
          style={{ cursor: "pointer", width: "fit-content" }}
        >
          <MdKeyboardArrowLeft size={30} />
          <Text fw={400} fz={12} c={"#262626"} ff={"Inter"}>
            Back
          </Text>
        </Flex>
        <AddButton title={"New Facility Type"} onClick={open} />
      </Box>
      <Box className={classes.table}>
        <FacilityTypeTable />
        <CustomPagination
          data={facilityTypes.count}
          itemsPerPage={10}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
        />
      </Box>
    </Box>
  );
};

export default FacilityType;
